import server from "@/utils/server";
// 产品列表
export const productsListTree = ()=> {
    return server.http("get", `/biz/products/list/tree`);
}
// 产品列表
export const productsList = (pageSize,type)=> {
    return server.http("get", `/biz/products/list?pageNum=1&pageSize=${pageSize}&type=${type}`);
}
// 产品列表name
export const productsListNameId = (pageSize,name,id)=> {
    return server.http("get", `/biz/products/list?pageNum=1&pageSize=${pageSize}&name=${name}&id=${id}`);
}
// 产品子信息
export const childList = (pageSize,id)=> {
    return server.http("get", `/biz/child/list?pageNum=1&pageSize=${pageSize}&productsId=${id}`);
}
// url列表
export const imgList = (type)=> {
    return server.http("get", `/biz/picture/list?pageNum=1&pageSize=10&type=`+ type);
}
// 全局参数配置-分页列表查询
export const configList = ()=> {
    return server.http("get", `/biz/config/list`);
}
// 全局参数配置-产品分类列表
export const productTypeList = ()=> {
    return server.http("get", `/system/dict/data/list?pageNum=1&pageSize=1000&dictType=products_type`);
}
// 图片列表+分页
export const imgPageList = (type, pageNum, pageSize) => {
    return server.http("get", `/biz/picture/list?pageNum=${pageNum}&pageSize=${pageSize}&type=${type}`);
}
// 留言-添加
export const guestbook = (data) => {
    return server.http("post", `/biz/guestbook`, data);
}
